import * as React from 'react';
import Grid from '@material-ui/core/Grid';

import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { paymentService } from 'services/PaymentService';
import { ICartModel } from 'interfaces/ICartModel';
import FieldText from 'components/Field/Text';
import Translate from 'components/Translate';
import { enLang } from 'interfaces/IProductData';
import { parameterService } from 'services/ParameterService';
import { enParameters } from 'enums/enParameters';
import { langService } from 'services/LangService';

interface IState extends IStateBase {
  model: ICartModel;
  isPersonF: boolean;
  lang: enLang;
}

export default class CpfForm extends BaseComponent<IState> {

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    this.bindModel(paymentService.getCart());
    this.observeState({ isPersonF: false }, parameterService.get(enParameters.df).map(df => !!df));
    this.observeState({ lang: null }, langService.getLang());
  }

  setDocument = (document: any) => {
    paymentService.setData({ document });
  }

  render() {

    if (!this.state) {
      return <div />;
    }

    const { model, lang, isPersonF } = this.state;

    const rule = (model.document || '').length > 11 ? 'cnpj' : 'cpf';

    return (
      <div>
        {lang == enLang.PT_BR ?
          <Grid container spacing={0}>
            <Grid item xs={12}>
              {!isPersonF ?
                <FieldText
                  id='document'
                  label={<Translate term='CPF ou CNPJ' />}
                  validation={lang == enLang.PT_BR ? 'required|' + rule : 'required|min:3|max:32'}
                  value={model.document}
                  mask={lang == enLang.PT_BR ? 'cpfCnpj' : null}
                  inputProps={{
                    className: 'theme-input',
                    pattern: '[0-9]*',
                    inputMode: 'numeric',
                    type: 'tel'
                  }}
                  InputLabelProps={{
                    className: 'theme-label',
                    id: 'label-credit-card-document'
                  }}
                  onChange={this.setDocument}
                />
                :
                <FieldText
                  id='document'
                  label={<Translate term={lang == enLang.PT_BR ? 'CPF' : 'Document ID / VAT / TAX ID'} />}
                  validation={lang == enLang.PT_BR ? 'required|' + rule : 'required|min:3|max:32'}
                  value={model.document}
                  mask={lang == enLang.PT_BR ? 'cpf' : null}
                  inputProps={{
                    className: 'theme-input',
                    pattern: '[0-9]*',
                    inputMode: 'numeric',
                    type: 'tel'
                  }}
                  InputLabelProps={{
                    className: 'theme-label'
                  }}
                  onChange={this.setDocument}
                />
              }
            </Grid>
          </Grid> :
          null
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/MainForm/Payment/PaymentForm/CpfForm/index.tsx